import * as mobx from 'mobx'
import store from 'store'

import ExecutionEnvironment from 'exenv'

import cookie from '../utils/cookie'
import authCookie from '../utils/authCookie'

/*
  Will listen to the Auth store and automatically
  save it's state onto the browser's localStorage
*/

const autoStore = function (key, _this) {
  let initialRun = true
  const isSSR = !ExecutionEnvironment.canUseDOM

  // will run on change
  mobx.autorun(() => {
    if (isSSR) {
      return
    }

    // on load check if there's an existing store on localStorage and extend the store
    if (initialRun) {
      const existingStore = store.get(key) || {}

      if (key === 'auth') {
        const c = cookie.getCookie('token')
        if (c) {
          try {
            mobx.set(_this, {
              ...existingStore,
              ...{ token: authCookie.parse(c) }
            })
          } catch (e) {
            console.log(e)
            mobx.set(_this, existingStore)
          }
        }
      } else {
        mobx.set(_this, existingStore)
      }
    }

    const { response, ..._nThis } = _this
    // from then on serialize and save to localStorage
    store.set(key, mobx.toJS(_nThis))
  })

  initialRun = false
}

export default autoStore



// WEBPACK FOOTER //
// ./src/stores/autoStore.js